import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { KieneTableService } from '../../../../components/kiene-table/kiene-table.service';
import { animate, style, transition, trigger } from '@angular/animations';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormControl, UntypedFormControl } from '@angular/forms';
import { MatAutocomplete } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';

import { Identifikation } from '../../../behandlungsanfrage/identifikation';
import {
    Gruppe,
    TierauswahlEvent,
} from '../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { IdentifikationDialogInput, IdentifikationDialogResult } from './identifikation-dialog';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { GruppeTier } from '../../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';

@Component({
    selector: 'kiene-identifikation-dialog',
    templateUrl: './identifikation-dialog.component.html',
    styleUrls: ['./identifikation-dialog.component.css'],
    animations: [
        trigger('freitextAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(-100%)' }),
                animate('500ms ease-in', style({ transform: 'translateX(0%)' })),
            ]),
            transition(':leave', [animate('10ms ease-out', style({ transform: 'translateX(-100%)' }))]),
        ]),
        trigger('tierauswahlAnimation', [
            transition(':enter', [
                style({ transform: 'translateX(100%)' }),
                animate('500ms ease-in', style({ transform: 'translateX(0%)' })),
            ]),
            transition(':leave', [animate('10ms ease-out', style({ transform: 'translateX(100%)' }))]),
        ]),
    ],
    host: { '(window:keydown)': 'checkForKeyShortcut($event)' },
})
export class IdentifikationDialogComponent implements OnInit, AfterViewInit {
    radioCtrl = new UntypedFormControl(0);
    prophylaxeCtrl = new FormControl();
    metaphylaxeCtrl = new FormControl();
    umwidmungCtrl = new FormControl();
    showSaveButton = true;

    identityCtrl = new UntypedFormControl();
    @ViewChild('identityCtrlRef', { static: false })
    identityCtrlRef: ElementRef<HTMLTextAreaElement>; // angular bug, geht nicht anders
    @ViewChild('autoIdentity') autoIdentity: MatAutocomplete;

    identifikationen: Observable<Identifikation[]>;

    gruppe: Gruppe = new Gruppe();
    tierauswahl: GruppeTier[] = [];

    anzahlTiereSollwert: number;
    identifikationTmp: string = null;
    alleTiereSelektiert = false;

    tiereAnzeigen = true;
    checkboxenAnzeigen = true;

    constructor(
        public dialogRef: MatDialogRef<IdentifikationDialogComponent>,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        @Inject(MAT_DIALOG_DATA) private input: IdentifikationDialogInput,
        private api: KieneTableService,
        private messageService: MessageService,
    ) {
        this.gruppe = this.input.gruppe;

        if (this.input.tiereAnzeigen === false) {
            this.tiereAnzeigen = false;
        }

        if (this.input.tiere && this.input.tiere.length > 0) {
            this.radioCtrl.setValue(1);
            this.tierauswahl = this.input.tiere;
        }

        if (this.input?.identifikation) {
            this.identifikationTmp = this.input.identifikation;
        }

        if (this.input?.prophylaxe > 0) {
            this.prophylaxeCtrl?.setValue(true, { emitEvent: false });
        } else if (this.input?.metaphylaxe > 0) {
            this.metaphylaxeCtrl?.setValue(true, { emitEvent: false });
        }
        if (this.input?.umwidmung > 0) {
            this.umwidmungCtrl?.setValue(true, { emitEvent: false });
        }

        if (this.input.anzahlTiere) {
            this.anzahlTiereSollwert = this.input.anzahlTiere;
        }

        if (this.input.checkboxenAnzeigen === false) {
            this.checkboxenAnzeigen = false;
        }

        this.prophylaxeCtrl?.valueChanges.subscribe({
            next: (value: boolean) => {
                if (value === true) {
                    this.metaphylaxeCtrl?.setValue(false, { emitEvent: false });
                }
            },
        });
        this.metaphylaxeCtrl?.valueChanges.subscribe({
            next: (value: boolean) => {
                if (value === true) {
                    this.prophylaxeCtrl?.setValue(false, { emitEvent: false });
                }
            },
        });
    }

    ngOnInit(): void {
        if (!this.tiereAnzeigen) {
            // 0 = Freitext
            this.radioCtrl.setValue(0);
        }
        this.autocompleteIdentifikationen();
    }

    ngAfterViewInit() {
        if (this.identifikationTmp) {
            setTimeout(() => (this.identityCtrlRef.nativeElement.value = this.identifikationTmp), 200); // // angular bug, geht nicht anders
        }
    }

    setTiere(event: TierauswahlEvent) {
        this.tierauswahl = event.tiere;
        this.alleTiereSelektiert = event.alleSelektiert;
        this.metaphylaxeDefault();
    }

    close() {
        this.dialogRef.close(null);
    }

    save() {
        const result = new IdentifikationDialogResult();
        result.confirm = true;
        result.identifikationTyp = this.radioCtrl.value === 0 ? 'freitext' : 'tierauswahl';
        result.freitext = this.getFreitext();
        result.tiere = this.tierauswahl;
        result.alleSelektiert = this.alleTiereSelektiert;
        result.prophylaxe = this.prophylaxeCtrl?.value === true ? 1 : 0;
        result.metaphylaxe = this.metaphylaxeCtrl?.value === true ? 1 : 0;
        result.umwidmung = this.umwidmungCtrl?.value === true ? 1 : 0;
        this.dialogRef.close(result);
    }

    getFreitext(): string {
        return this.identityCtrlRef?.nativeElement.value; // angular bug, geht nicht anders
    }

    autocompleteIdentifikationen() {
        this.identifikationen = this.identityCtrl.valueChanges.pipe(
            debounceTime(100),
            distinctUntilChanged(),
            switchMap(() => {
                this.metaphylaxeDefault();
                return this.searchIdentifikationen(this.getFreitext());
            }),
        );
    }

    searchIdentifikationen(value: string): Observable<Identifikation[]> {
        if (!this.gruppe?.kunde_id) {
            return new Observable<Identifikation[]>();
        }
        let params = new HttpParams();
        params = params.set('kunde_id', this.gruppe.kunde_id.toString());
        params = params.set('search', value);
        return this.api.get(this.apiBaseUrl + 'identifikation/read.php', params).pipe(
            debounceTime(300),
            distinctUntilChanged(),
            map(response => response.records),
        );
    }

    metaphylaxeDefault() {
        if (!(this.metaphylaxeCtrl?.value === true) && !(this.prophylaxeCtrl?.value === true)) {
            this.metaphylaxeCtrl?.setValue(true, { emitEvent: false });
        }
    }

    deleteIdentifikation(identifikation: Identifikation, event: Event) {
        event.stopPropagation();
        this.api.deleteEntity(this.apiBaseUrl + 'identifikation/delete.php', identifikation).subscribe({
            next: () => {
                this.identifikationen = this.searchIdentifikationen(this.getFreitext());
            },
            error: err => {
                this.messageService.errorMessage('Die Identifikation konnte nicht gelöscht werden!', err);
            },
        });
    }

    identityMapper(identifikation: Identifikation) {
        if (identifikation) {
            return identifikation.bezeichnung;
        }
        return '';
    }

    checkForKeyShortcut(event: KeyboardEvent) {
        if (this.isTextarea) {
            if ((event.ctrlKey || event.altKey) && event.key === 'Enter') {
                event.preventDefault();
                let s = this.getFreitext();
                s += '\n';
                this.identityCtrlRef.nativeElement.value = s;
            } else if (event.key === 'Enter') {
                event.preventDefault();
                this.save();
            }
        }
    }

    private isTextarea(event: KeyboardEvent): boolean {
        if (event.target instanceof Node) {
            switch (event.target.nodeName) {
                case 'TEXTAREA':
                    return true;
            }
        }
        return false;
    }
}
